import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon, BookOpenIcon, HeadphonesIcon } from 'lucide-react';
export function HeroSection() {
  return <header className="relative min-h-[80vh] flex flex-col items-center justify-center px-4 py-16 overflow-hidden border-b border-gold-900/30" data-id="element-72">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-noise opacity-[0.03] pointer-events-none mix-blend-overlay" data-id="element-73"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-96 bg-gold-900/10 blur-[120px] rounded-full pointer-events-none" data-id="element-74"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center space-y-6" data-id="element-75">
        <div className="animate-float inline-flex items-center gap-3 px-4 py-1.5 text-xs md:text-sm font-sans font-bold tracking-widest text-gold-400 border border-gold-500/30 bg-gold-950/40 uppercase mb-2 rounded-full backdrop-blur-sm shadow-[0_0_15px_rgba(201,168,76,0.1)]" data-id="element-76">
          <StarIcon className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-77" />
          THE #1 MANIFESTO OF THE YEAR
          <StarIcon className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-78" />
        </div>

        <h1 className="md:text-8xl lg:text-9xl font-black tracking-tight text-shadow-md text-[48px]" data-id="element-79">
          The day{' '}
          <span className="text-transparent bg-clip-text bg-gold-gradient text-shadow-gold" data-id="element-80">
            silence
          </span>{' '}
          tried to win
        </h1>

        {/* eBook Cover */}
        <div className="flex justify-center py-4" data-id="element-81">
          <div className="relative" data-id="element-82">
            <div className="absolute -inset-4 bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-83"></div>
            <img src="https://cdn.magicpatterns.com/uploads/eQzqZdVop5T2cqa11AGZRp/cover.png" alt="The Voice They Couldn't Silence — eBook Cover" className="relative w-56 md:w-72 lg:w-80 h-auto drop-shadow-[0_20px_50px_rgba(201,168,76,0.3)] hover:scale-105 transition-transform duration-500" data-id="element-84" />
          </div>
        </div>

        {/* Format badges: eBook + Audiobook */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3" data-id="element-85">
          <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/[0.03] border border-white/10" data-id="element-86">
            <BookOpenIcon className="w-4 h-4 text-gold-400" data-id="element-87" />
            <span className="text-zinc-200 text-sm font-medium" data-id="element-88">eBook PDF</span>
          </div>
          <span className="text-gold-500 font-bold" data-id="element-89">+</span>
          <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gold-950/30 border border-gold-500/30 shadow-[0_0_10px_rgba(201,168,76,0.1)]" data-id="element-90">
            <HeadphonesIcon className="w-4 h-4 text-gold-400" data-id="element-91" />
            <span className="text-gold-100 text-sm font-medium" data-id="element-92">
              Audiobook MP3
            </span>
            <span className="text-[9px] font-bold tracking-widest text-gold-950 bg-gold-gradient px-2 py-0.5 rounded-full uppercase" data-id="element-93">
              Bonus
            </span>
          </div>
        </div>

        <p className="max-w-3xl mx-auto text-2xl md:text-3xl font-serif italic text-zinc-300 leading-relaxed" data-id="element-94">
          The chronicle of the sacrifice that changed the future of the West.
        </p>

        <div className="w-32 h-px bg-gradient-to-r from-transparent via-gold-600 to-transparent mx-auto my-6" data-id="element-95"></div>

        <p className="max-w-4xl mx-auto text-xl md:text-2xl text-zinc-400 leading-relaxed font-medium" data-id="element-96">
          When arguments can no longer defeat the truth, they resort to
          violence. <br className="hidden md:block" data-id="element-97" />
          <span className="text-gold-100 font-bold bg-gold-900/20 px-3 py-1 mt-4 inline-block border border-gold-800/30 rounded" data-id="element-98">
            Read the exclusive warning before they silence the truth forever.
          </span>
        </p>

        <div className="pt-8 flex flex-col items-center gap-4" data-id="element-99">
          <CTAButton data-id="element-100">CLAIM YOUR COPY NOW — BEFORE IT'S GONE</CTAButton>
          <p className="text-sm font-mono text-gold-600/80 uppercase tracking-widest" data-id="element-101">
            Join 10,000+ readers who already claimed their copy
          </p>
        </div>
      </div>
    </header>;
}